// extracted by mini-css-extract-plugin
export default {"container":"CRigeyG6NrI2XQeVAoNl"};